<template>
  <v-form class="sales-signup-form">
    <v-container fluid>
      <v-row class="px-0">
        <v-col cols="6">
          <v-text-field
            label="Solo"
            hide-details="auto"
            placeholder="First Name"
            v-model="firstName"
            solo
            dense
            flat
            ref="firstName"
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            label="Solo"
            hide-details="auto"
            placeholder="Last Name"
            v-model="lastName"
            solo
            dense
            flat
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="px-0">
        <v-col cols="6">
          <v-text-field
            label="Solo"
            hide-details="auto"
            placeholder="Company Name"
            v-model="company"
            solo
            dense
            flat
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            label="Solo"
            hide-details="auto"
            placeholder="Position"
            v-model="position"
            solo
            dense
            flat
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="px-0">
        <v-col cols="6">
          <v-text-field
            label="Solo"
            hide-details="auto"
            placeholder="Email"
            v-model="email"
            solo
            dense
            flat
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-tel-field
            label=""
            solo
            dense
            flat
            v-model="phone"
            placeholder="PhoneNumber"
            hide-details="auto"
          ></v-tel-field>
        </v-col>
      </v-row>
      <v-row class="px-0">
        <v-col cols="12">
          <v-btn color="appRed" @click="createLead()" class="white--text w-100"
            >SIGN UP</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
export default {
  name: "SignupFormComponent",
  data: () => ({
    firstName: null,
    lastName: null,
    company: null,
    position: null,
    email: null,
    phone: null
  }),
  computed: {
    state() {
      return this.$route.name.toLowerCase();
    }
  },
  methods: {
    createLead() {
      let payLoad = {
        firstName: this.firstName,
        lastName: this.lastName,
        company: this.company,
        position: this.position,
        email: this.email,
        phone: this.phone
      };

      this.$store
        .dispatch(this.state + "/CREATE_LEAD", payLoad)
        .then(() => {
          this.$swal(
            "Success!",
            "We have received your signup. We will be in touch soon!",
            "success"
          );
        })
        .catch(error => {
          this.$swal("error", error.message, "error");
        });
    }
  }
};
</script>
<style scoped lang="scss" src="./SalesPage.scss"></style>
<style lang="scss">
.sales-signup-form {
  .v-text-field.v-input--dense:not(.v-text-field--enclosed):not(.v-text-field--full-width) .v-input__append-inner .v-input__icon > .v-icon {
    margin-top: 0px;
  }
}
</style>
